<template>
    <div class="m-dropdown__container" v-on:click.stop="toggleThisDropdown">
        <button class="a-button a-button--header-button"
                :class="{'a-button--dropdown' : isADropdown, 'a-button--no-bottom-radius' : isThisDropdownOpen}">{{buttonName}}
        </button>
        <div class="m-dropdown" :class="[dropdownName, { 'm-dropdown--show' : isThisDropdownOpen }]">
            <slot @click="menuContentClicked"></slot>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: 'dropdown',
        props: {
            dropdownName: {
                type: String,
                default: '',
            },
            isADropdown: {
                type: Boolean,
                default: false,
            },
            buttonName: {
                type: String,
                default: '',
            }
        },
        computed: {
            ...mapGetters('dropdown', ['dropdowns']),
            isThisDropdownOpen: {
                get() {
                    return this.dropdowns[this.name];   
                },
            }
        },
        created(){
            this.register(this.name);
        },
        methods: {
            ...mapActions('dropdown', ['toggle', 'register', 'unregister', 'close']),
            toggleThisDropdown(message, event){
                this.toggle(this.name);
                if (event) {
                    event.preventDefault();
                }
                if(this.isThisDropdownOpen == true) {
                    document.body.addEventListener('click', this.closeDropdown);
                }
                window.addEventListener('keyup', (event) => {
                    document.body.removeEventListener('click', this.closeDropdown);
                    if (event.keyCode === 27 && this.isThisDropdownOpen == true) {
                        this.close(this.name);
                    }
                });
            },
            menuContentClicked() {
                this.close(this.name);
            },
            closeDropdown() {
                document.body.removeEventListener('click', this.closeDropdown);
                this.close(this.name);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Dropdown.vue?0f1439f0